/* eslint-disable import/no-anonymous-default-export */
export default (specificAdvice = [], action) => {
  switch (action.type) {
    case "GET_ALL_SPECIFIC_BRANCH_ADVICE":
      return action.payload;
    default:
      return specificAdvice;
  }
};
